module.exports = __webpack_public_path__ + "img/review.f5903778.svg";